import { div } from "framer-motion/client"
import styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import TextBoxComponent from "./TextBoxComponent";
import { Observer } from "mobx-react";
import MCQOption from "../screens/Questionare/MCQOption";
import QuestionareStore from "../stores/QuestionareStore";
import { useState } from "react";
import RatingSlider from "./RatingSlider";
import AudioPlayer from "./AudioPlayer";
import VideoPlayer from "./VideoPlayer";


const IC_Component = ({item, isHindi}) => {
    //caption
    //display text
    //helper text
    //image/ option/ select_type: text_area
    const [inputVal, setInputVal] = useState('')
    return (
      <Observer>
        {()=>{return(
          <div>
            {item.caption_text && (
                <p
                className={styles.QuestionLabel}
              >
                {item.caption_text}
              </p>
            )}

            {!item.image_file && item.screen_type==="display" &&(
              <div className={styles.StackedText} style={{ paddingTop: '3rem' }}>
                {item.display_text && (
                  <p className={styles.Question} style={{ paddingBottom: '1rem' }}>
                    {item.display_text}
                  </p>
                )}
                {item.helper_text && (
                  <p className={styles.QuestionLabel}>
                    {item.helper_text}
                  </p>
                )}
              </div>
            )}

            {/* Case 2: There is an image file. */}
            {(item.screen_type === "input" || item.screen_type === "output") && (
              <>
                {item.display_text && (
                  <p className={styles.Question} style={{ paddingBottom: '1rem' }}>
                    {item.display_text}
                  </p>
                )}
                {item.helper_text && (
                  <p className={styles.QuestionLabel} style={{paddingLeft: '0.5rem', paddingRight: '0.5rem'}}>
                    {item.helper_text}
                  </p>
                )}
              </>
            )}


            {/* image in case present */}
            <div>
            {(item.image_file) && (
              <div className={styles.StackedText} style={{ display: "flex", justifyContent: "center"}}>
                <div style={{
                  width: '25rem',
                  // height: '33rem',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                  <img
                    src={item.image_file}
                    alt=""
                    style={{
                      transform: 'scale(0.75)',
                      width: '100%',
                      // minHeight: '100%',
                      maxHeight: '490px',
                      objectFit: 'cover',
                      objectPosition: '50% 55%',
                      marginTop: '-4rem',
                      display: 'block',
                    }}
                  />
                </div>
              </div>
            )}
          </div>
            
            

            {/* render audio */}
            {(item.select_type === "text_audio" || item.screen_label === "audio" || !!item.source_link) && (
              <AudioPlayer audio_url={item.source_link} />
            )}


            {/* render video */}
            {item.select_type === "text_video" && (
              <VideoPlayer video_url={item.source_link} />
            )}

            {/* text field if select_type: text_textarea */}
            {item.select_type==="text_textarea" && (
              <TextBoxComponent inputKey={item.counter} isHindi={isHindi}/>
            )}

            {/* render optons if present */}
            {/* render options if select_type is multi_select or single_select */}
            {(item.select_type === "multi_select" || item.select_type === "single_select") && item.options.length > 0 && (
              <div style={{ height: '40vh', overflowY: 'auto' }}>
                {item.options.map((option, index) => (
                  <MCQOption
                    isSelected={
                      (QuestionareStore.selectedOptions[QuestionareStore.currentStepIndex] || []).includes(index)
                    }
                    key={index}
                    text={option.option_name}
                    onClick={() => QuestionareStore.selectOption(index)}
                  />
                ))}
              </div>
            )}
            
            {/* render slider if select_type is range_select_5 or range_select_10 */}
            {(item.select_type === 'range_select_5' || item.select_type === 'range_select_10') && (
              <RatingSlider
                ratingKey={item.counter}
                maxLimit={item.select_type === 'range_select_5' ? 5 : 10}
              />
            )}

        </div>
        )}}

      </Observer>
    )
}

export default IC_Component